var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfetti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#B1CEFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2064_74773)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    fill: "white",
    stroke: "#6092DB",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.3048,
    cy: 17.2147,
    rx: 1.71097,
    ry: 6.0784,
    transform: "rotate(-45 18.3048 17.2147)",
    stroke: "#6092DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13L8 27L22 22",
    stroke: "#6092DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.5L15 15.5H13L12 18.5H17.5Z",
    fill: "#6092DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 26.5L13.5 25H9L8.5 27L9 26.5Z",
    fill: "#6092DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 23H19.5L21.5 22L18.5 20H11L10 23Z",
    fill: "#6092DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7C18.1667 7.66667 19.1 9.6 17.5 12",
    stroke: "#6092DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0011 14.5C19.6678 13.6667 19.6011 11.9 22.0011 11.5C25.0011 11 25.501 14 24.001 14C22.501 14 20.501 10.5 25.501 8",
    stroke: "#6092DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 18.0001C24.3333 17.3334 26.4 16.3001 28 17.5001",
    stroke: "#6092DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 6,
    r: 1,
    fill: "#6092DB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 20,
    r: 1,
    fill: "#6092DB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 13,
    r: 1,
    fill: "#6092DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2064_74773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.7266e6ff999a1400879f036454aa2a8b.svg";
export { ForwardRef as ReactComponent };